import { useMutation } from 'react-query';
import { TaskCenterService } from '../constants';
import { SchemaTaskCenterV2 } from '../service';
import { ListTasksRequestV2 } from '../types/schema-exports.types';
import type { CreateTasksRequest, UpdateTaskRequest, DeleteTaskRequest } from '../types_deprecated';

export const useTaskCenterMutations = () => {
  const taskCreateMutation = useMutation((params: CreateTasksRequest) => TaskCenterService.CreateTasks(params));

  const taskUpdateMutation = useMutation((params: UpdateTaskRequest) => TaskCenterService.UpdateTask(params));

  const taskDeleteMutation = useMutation((params: DeleteTaskRequest) => TaskCenterService.DeleteTask(params));

  const getTaskByTaskDetailsMutation = useMutation((params: ListTasksRequestV2) =>
    SchemaTaskCenterV2.ListTasksV2(params)
  );

  return {
    taskCreateMutation,
    taskDeleteMutation,
    taskUpdateMutation,
    getTaskByTaskDetailsMutation,
  };
};
